import { DEFAULT_METEO_ENABLED } from '@ergo/shared';
import { useState } from 'react';
import { api, errorMessage } from '../../api';
import { useResource } from '../../hooks';
import { formatSyncMoment } from '../../perso';

/**
 * Elle fait ses visites à vélo : savoir qu'il pleuvra à 14 h change ce qu'elle met
 * dans la sacoche le matin. Les prévisions sont demandées autour de la maison,
 * arrondie au kilomètre — le point exact ne sort jamais du serveur.
 */
export function Meteo() {
  const settings = useResource(() => api.settings.get(), []);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const enabled = settings.data?.meteoEnabled ?? DEFAULT_METEO_ENABLED;
  const home = settings.data?.home ?? null;
  // Sans coordonnées, il n'y a pas de point à demander : la météo se tait.
  const located = home?.lat != null && home.lng != null;
  const fetchedAt = settings.data?.meteoFetchedAt ?? null;
  const syncError = settings.data?.meteoError ?? null;

  async function onToggle(next: boolean) {
    setPending(true);
    setError(null);
    try {
      await api.settings.update({ meteoEnabled: next });
      settings.reload();
    } catch (cause) {
      setError(errorMessage(cause));
    } finally {
      setPending(false);
    }
  }

  return (
    <section className="panel">
      <h2 className="panel__title">Météo</h2>

      <label className={`switch${enabled ? ' is-on' : ''}`}>
        <span className="switch__text">
          <span className="switch__label">Météo du jour</span>
          <span className="hint">
            Le temps qu’il fait en tête d’Aujourd’hui, et un mot quand il faut prendre la tenue.
          </span>
        </span>
        <input
          type="checkbox"
          role="switch"
          aria-checked={enabled}
          checked={enabled}
          disabled={pending || settings.loading}
          onChange={(event) => void onToggle(event.target.checked)}
        />
        <span className="switch__track" aria-hidden="true">
          <span className="switch__knob" />
        </span>
      </label>

      {error && (
        <p className="error" role="alert">
          {error}
        </p>
      )}

      {/* Les prévisions sont un décor : un échec se dit, il n'alarme pas. */}
      {enabled &&
        (located ? (
          <p className={syncError ? 'note-sun' : 'hint'}>
            {syncError
              ? `Prévisions non mises à jour : ${syncError}.`
              : fetchedAt
                ? `Prévisions à jour ${formatSyncMoment(fetchedAt)}`
                : 'Prévisions en cours de récupération…'}
          </p>
        ) : (
          <p className="hint">Renseigne l’adresse de la maison pour avoir la météo.</p>
        ))}

      <p className="hint">
        Prévisions Open-Meteo — modèles de Météo-France et européens — autour de la maison, à
        1 km près. Le point exact de la maison n’est jamais envoyé.
      </p>
      <p className="hint">
        Météo :{' '}
        <a href="https://open-meteo.com/" target="_blank" rel="noopener">
          Open-Meteo.com
        </a>
      </p>
    </section>
  );
}
